<template>
  <div class="trilateralRecordDialog">
    <el-dialog
      title="预约记录"
      :visible.sync="visible"
      width="960px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="true"
      :before-close="close">
      <div class="content">
        <div class="header">
          <div class="header_item">
            <div class="header_item_label">姓名</div>
            <el-input class="header_item_input" v-model.trim="form.patientName" placeholder="请输入" clearable></el-input>
          </div>
          <div class="header_item">
            <div class="header_item_label">电话</div>
            <el-input class="header_item_input" v-model.trim="form.patientPhone" placeholder="请输入" clearable></el-input>
          </div>
          <div class="header_btns">
            <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
            <el-button icon="el-icon-refresh" @click="reset">重置</el-button>
          </div>
        </div>
        <div class="table">
          <el-table :data="list">
            <el-table-column type="index" :index="tableIndexMethod" label="序号" width="50"></el-table-column>
            <el-table-column label="姓名" prop="patientName" min-width="100"></el-table-column>
            <el-table-column label="电话" prop="patientPhone" min-width="130"></el-table-column>
            <el-table-column label="商品名称" prop="physioProducts" min-width="200" show-overflow-tooltip></el-table-column>
            <el-table-column label="执行医生" prop="doctorName" min-width="120"></el-table-column>
            <el-table-column label="预约时间" prop="reservationTime" min-width="200"></el-table-column>
            <el-table-column label="预约状态" prop="doctorName" min-width="120">
              <template slot-scope="scope">
                <div :class="`reservationStatusTag ${scope.row.reservationStatusClass}`">{{ scope.row.reservationStatusText }}</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination">
          <el-pagination
            :current-page="pageNo"
            :page-size="pageSize"
            background
            layout="total, prev, pager, next"
            :total="total"
            @current-change="pageNoChange">
          </el-pagination>
        </div>
      </div>
      <div slot="footer">
        <el-button type="primary" @click="close">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { getTrilateralReservationRecord } from '@/api/physio.js'

  const reservationStatusMap = {
    1: { text: '预约成功', class: 'success' },
    2: { text: '已取消', class: 'cancel' },
    3: { text: '已执行', class: 'cancel' },
    4: { text: '已停诊', class: 'fail' },
    5: { text: '已结束', class: 'cancel' }
  }
  export default {
    name: 'trilateralRecordDialog',
    data () {
      return {
        visible: false,
        loading: false,
        form: {
          patientName: '',
          patientPhone: ''
        },
        pageNo: 1,
        pageSize: 10,
        list: [],
        total: 0
      }
    },
    methods: {
      tableIndexMethod (index) {
        return (this.pageNo - 1) * this.pageSize + index + 1
      },
      async getList () {
        this.loading = true
        const res = await getTrilateralReservationRecord({
          ...this.form,
          deptId: sessionStorage.getItem('deptId'),
          pageNum: this.pageNo,
          pageSize: this.pageSize,
          source: 'platform-intermediary'
        })
        this.loading = false
        if (res.code === 200) {
          this.list = res.rows.map(v => {
            v['physioProducts'] = v.physioDetails.map(physio => { return physio.drugKindName }).join(',')
            v['reservationTime'] = `${new Date(v.reservationStartTime).Format('MM-dd')} ${new Date(v.reservationStartTime).Format('hh:mm')}~${new Date(v.reservationEndTime).Format('hh:mm')}`
            v['reservationStatusText'] = reservationStatusMap[v.reservation] && reservationStatusMap[v.reservation].text || ''
            v['reservationStatusClass'] = reservationStatusMap[v.reservation] && reservationStatusMap[v.reservation].class || ''
            return v
          })
          this.total = res.total
        }
      },
      pageNoChange (num) {
        this.pageNo = num
        this.getList()
      },
      open () {
        this.visible = true
        this.pageNo = 1
        this.getList()
      },
      close () {
        this.visible = false
        this.form.patientName = ''
        this.form.patientPhone = ''
        this.pageNo = 1
        this.list = []
      },
      search () {
        this.pageNo = 1
        this.getList()
      },
      reset () {
        this.form.patientName = ''
        this.form.patientPhone = ''
        this.pageNo = 1
        this.getList()
      }
    }
  }
</script>

<style lang="less" scoped>
  .trilateralRecordDialog{
    overflow: hidden;
  }

  .trilateralRecordDialog /deep/ .el-dialog__header {
    padding: 16px 20px;
    border-bottom: 1px solid #E5E6EB !important;
  }

  .trilateralRecordDialog /deep/ .el-dialog__title {
    font-weight: bold;
    font-size: 16px;
    color: #1F2329;
  }
  
  .trilateralRecordDialog /deep/ .el-dialog__body {
    padding: 0;
  }

  .trilateralRecordDialog /deep/ .el-dialog__footer {
    padding: 12px 20px;
  }

  .content {
    box-sizing: border-box;
    padding: 20px;
    width: 100%;
  }

  .header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
  }

  .header_item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .header_item+.header_item {
    margin: 0 0 0 24px;
  }

  .header_item_label {
    font-size: 14px;
    color: #1F2329;
  }

  .header_item_input {
    margin: 0 0 0 16px;
    width: 200px;
  }

  .header_btns {
    margin: 0 0 0 12px;
  }

  .table {
    margin: 24px 0 0 0;
    width: 100%;
  }

  .reservationStatusTag {
    padding: 0 6px;
    width: fit-content;
    height: 24px;
    line-height: 24px;
    font-size: 13px;
    border-radius: 2px;
  }

  .reservationStatusTag.success {
    color: #29C01B;
    background-color: #E0FADD;
  }

  .reservationStatusTag.cancel {
    color: #667182;
    background-color: #F0F1F3;
  }

  .reservationStatusTag.fail {
    color: #F56C6C;
    background-color: #FDE2E2;
  }

  .pagination {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin: 24px 0 0 0;
    width: 100%;
  }
</style>